import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\ModelNotification\MarkFavoriteModelNotificationController::__invoke
* @see app/Http/Controllers/ModelNotification/MarkFavoriteModelNotificationController.php
* @route '/api/mark-favorite'
*/
const MarkFavoriteModelNotificationController = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: MarkFavoriteModelNotificationController.url(options),
    method: 'post',
})

MarkFavoriteModelNotificationController.definition = {
    methods: ["post"],
    url: '/api/mark-favorite',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\ModelNotification\MarkFavoriteModelNotificationController::__invoke
* @see app/Http/Controllers/ModelNotification/MarkFavoriteModelNotificationController.php
* @route '/api/mark-favorite'
*/
MarkFavoriteModelNotificationController.url = (options?: RouteQueryOptions) => {
    return MarkFavoriteModelNotificationController.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\ModelNotification\MarkFavoriteModelNotificationController::__invoke
* @see app/Http/Controllers/ModelNotification/MarkFavoriteModelNotificationController.php
* @route '/api/mark-favorite'
*/
MarkFavoriteModelNotificationController.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: MarkFavoriteModelNotificationController.url(options),
    method: 'post',
})

export default MarkFavoriteModelNotificationController